module.exports = __webpack_public_path__ + "static/img/newapp10.d890a2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newapp10.png
// module id = H9I5
// module chunks = 136